import Checkbox from '@material-ui/core/Checkbox';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import HeaderPage from '~/components/HeaderPage';
import { ApplicationState } from '~/store';
import { personalExportLogRequest } from '~/store/ducks/ExportarInformacoesOperacoes/actions';
import { consentimentosRequest } from '~/store/ducks/GerenciarConsentimento/actions';
import { personalRequest } from '~/store/ducks/MostrarInformacoesPessoais/actions';
import Categorias from '../MostrarInformacoesPessoais/categorias';
import { Container, FormControlLabelLGPD, StyledButton } from './styles';

interface StateProps {
  profile: any;
  language: any;
  personalState: any;
  consentimentos: any;
}

interface DispatchProps {
  consentimentosRequest(newPage: any, rowsPerPage: any): void;
  personalExportLogRequest(): void;
}

type Props = StateProps & DispatchProps;
interface Keys {
  key: string;
  value: boolean;
}

interface State {
  tipo?: any;
  key: string[];
  personal?: any;
  isVerified: boolean;
}

class ExportarInformacoesOperacoes extends Component<Props> {
  state: State = {
    isVerified: false,
    personal: {
      tipo: 0,
      assinante: [],
      dados_cadastrais_funcionario: [],
      instaladores: [],
      pontos_de_venda: [],
      terceiros: [],
      propostas: [],
      proposta: [],
      dados_cadastrais_candidato: [],
      generic_logical_unit_json: [],
    },
    key: [],
  };

  componentDidMount() {
    //@ts-ignore
    const { personalRequest } = this.props;
    personalRequest(0);

    document.title = 'Exportar Informações e operações | Portal LGPD';
  }

  //@ts-ignore
  verifyCallback = response => {
    if (response) {
      this.setState({ isVerified: true });
    }
  };

  expiredCallback = () => {
    this.setState({ isVerified: false });
  };

  handleChecked = async (value: Keys) => {
    //@ts-ignore
    const personalState = this.props.personalState.data;

    if (personalState?.tipo === 1) {
      const { key } = this.state;

      for (let i = 0; i < personalState?.assinante.length; i++) {
        const element = personalState?.assinante[i];
        if (element?.dadosPessoais?.Codigo_Cliente_Siebel === value.key) {
          const logtest = () => {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            let indexValue = personalState?.assinante?.findIndex(
              (index: any) =>
                index?.dadosPessoais?.Codigo_Cliente_Siebel ===
                this.state.key[indexKey],
            );

            this.setState({
              personal: {
                ...this.state.personal,
                tipo: personalState?.tipo,
                assinante: [
                  ...this.state.personal?.assinante,
                  personalState?.assinante[indexValue],
                ],
              },
            });
          };

          if (!this.state.key.includes(value.key)) {
            this.setState({ key: [...key, value.key] }, logtest);
          } else {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            const indexValue = this.state.personal?.assinante?.findIndex(
              (index: any) =>
                index?.dadosPessoais?.Codigo_Cliente_Siebel === value.key,
            );

            const removeItem = this.state.key;

            removeItem.splice(indexKey, 1);

            const removeItemIndexValue = this.state.personal?.assinante;

            removeItemIndexValue.splice(indexValue, 1);

            this.setState({
              key: removeItem,
              personal: {
                ...this.state.personal,
                assinante: removeItemIndexValue,
              },
            });
          }
        }
      }
    }

    if (personalState?.tipo === 2) {
      const { key } = this.state;

      for (
        let i = 0;
        i < personalState?.dados_cadastrais_funcionario.length;
        i++
      ) {
        const element = personalState?.dados_cadastrais_funcionario[i];
        if (element?.Dados_Cadastrais?.Matricula_Empregado === value.key) {
          const logtest = () => {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            let indexValue =
              personalState?.dados_cadastrais_funcionario?.findIndex(
                (index: any) =>
                  index?.Dados_Cadastrais?.Matricula_Empregado ===
                  this.state.key[indexKey],
              );

            this.setState({
              personal: {
                ...this.state.personal,
                tipo: personalState?.tipo,
                dados_cadastrais_funcionario: [
                  ...this.state.personal?.dados_cadastrais_funcionario,
                  personalState?.dados_cadastrais_funcionario[indexValue],
                ],
              },
            });
          };

          if (!this.state.key.includes(value.key)) {
            this.setState({ key: [...key, value.key] }, logtest);
          } else {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            const indexValue =
              this.state.personal?.dados_cadastrais_funcionario?.findIndex(
                (index: any) =>
                  index?.Dados_Cadastrais?.Matricula_Empregado === value.key,
              );

            const removeItem = this.state.key;

            removeItem.splice(indexKey, 1);

            const removeItemIndexValue =
              this.state.personal?.dados_cadastrais_funcionario;

            removeItemIndexValue.splice(indexValue, 1);

            this.setState({
              key: removeItem,
              personal: {
                ...this.state.personal,
                dados_cadastrais_funcionario: removeItemIndexValue,
              },
            });
          }
        }
      }
    }

    if (personalState?.tipo === 4) {
      const { key } = this.state;

      for (let i = 0; i < personalState?.instaladores.length; i++) {
        const element = personalState?.instaladores[i];
        if (element?.Numero_instalador === value.key) {
          const logtest = () => {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            let indexValue = personalState?.instaladores?.findIndex(
              (index: any) =>
                index?.Numero_instalador === this.state.key[indexKey],
            );

            this.setState({
              personal: {
                ...this.state.personal,
                tipo: personalState?.tipo,
                instaladores: [
                  ...this.state.personal?.instaladores,
                  personalState?.instaladores[indexValue],
                ],
              },
            });
          };

          if (!this.state.key.includes(value.key)) {
            this.setState({ key: [...key, value.key] }, logtest);
          } else {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            const indexValue = this.state.personal?.instaladores?.findIndex(
              (index: any) => index?.Numero_instalador === value.key,
            );

            const removeItem = this.state.key;

            removeItem.splice(indexKey, 1);

            const removeItemIndexValue = this.state.personal?.instaladores;

            removeItemIndexValue.splice(indexValue, 1);

            this.setState({
              key: removeItem,
              personal: {
                ...this.state.personal,
                instaladores: removeItemIndexValue,
              },
            });
          }
        }
      }

      for (let i = 0; i < personalState?.terceiros.length; i++) {
        const element = personalState?.terceiros[i];

        if (element.conta === value.key) {
          const logtest = () => {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            let indexValue = personalState?.terceiros?.findIndex(
              (el: any, index: any) => el.conta === this.state.key[indexKey],
            );

            this.setState({
              personal: {
                ...this.state.personal,
                tipo: personalState?.tipo,
                terceiros: [
                  ...this.state.personal?.terceiros,
                  personalState?.terceiros[indexValue],
                ],
              },
            });
          };

          if (!this.state.key.includes(value.key)) {
            this.setState({ key: [...key, value.key] }, logtest);
          } else {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            const indexValue = this.state.personal?.terceiros?.findIndex(
              (index: any) => index.conta === value.key,
            );

            const removeItem = this.state.key;

            removeItem.splice(indexKey, 1);

            const removeItemIndexValue = this.state.personal?.terceiros;

            removeItemIndexValue.splice(indexValue, 1);

            this.setState({
              key: removeItem,
              personal: {
                ...this.state.personal,
                terceiros: removeItemIndexValue,
              },
            });
          }
        }
      }

      for (let i = 0; i < personalState?.pontos_de_venda.length; i++) {
        const element = personalState?.pontos_de_venda[i];

        if (element.conta === value.key) {
          const logtest = () => {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            let indexValue = personalState?.pontos_de_venda?.findIndex(
              (el: any, index: any) => el.conta === this.state.key[indexKey],
            );
            this.setState({
              personal: {
                ...this.state.personal,
                tipo: personalState?.tipo,
                pontos_de_venda: [
                  ...this.state.personal?.pontos_de_venda,
                  personalState?.pontos_de_venda[indexValue],
                ],
              },
            });
          };

          if (!this.state.key.includes(value.key)) {
            this.setState({ key: [...key, value.key] }, logtest);
          } else {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            const indexValue = this.state.personal?.pontos_de_venda?.findIndex(
              (index: any) => index.conta === value.key,
            );
            const removeItem = this.state.key;

            removeItem.splice(indexKey, 1);

            const removeItemIndexValue = this.state.personal?.pontos_de_venda;

            removeItemIndexValue.splice(indexValue, 1);

            this.setState({
              key: removeItem,
              personal: {
                ...this.state.personal,
                pontos_de_venda: removeItemIndexValue,
              },
            });
          }
        }
      }
    }

    if (personalState?.tipo === 5) {
      const { key } = this.state;

      for (
        let i = 0;
        i < personalState?.dados_cadastrais_candidato?.length;
        i++
      ) {
        const element = personalState?.dados_cadastrais_candidato[i];
        if (element?.CPF_Candidato === value.key) {
          const logtest = () => {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            let indexValue =
              personalState?.dados_cadastrais_candidato?.findIndex(
                (index: any) =>
                  index?.CPF_Candidato === this.state.key[indexKey],
              );
            this.setState({
              personal: {
                ...this.state.personal,
                tipo: personalState?.tipo,
                dados_cadastrais_candidato: [
                  ...this.state.personal?.dados_cadastrais_candidato,
                  personalState?.dados_cadastrais_candidato[indexValue],
                ],
              },
            });
          };

          if (!this.state.key.includes(value.key)) {
            this.setState({ key: [...key, value.key] }, logtest);
          } else {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            const indexValue =
              this.state.personal?.dados_cadastrais_candidato?.findIndex(
                (index: any) => index?.CPF_Candidato === value.key,
              );

            const removeItem = this.state.key;

            removeItem.splice(indexKey, 1);

            const removeItemIndexValue =
              this.state.personal?.dados_cadastrais_candidato;

            removeItemIndexValue.splice(indexValue, 1);

            this.setState({
              key: removeItem,
              personal: {
                ...this.state.personal,
                dados_cadastrais_candidato: removeItemIndexValue,
              },
            });
          }
        }
      }

      for (let i = 0; i < personalState?.propostas?.length; i++) {
        const element = personalState?.propostas[i];
        if (element?.Numero_Proposta_Prosponente === value.key) {
          const logtest = () => {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            let indexValue = personalState?.propostas?.findIndex(
              (index: any) =>
                index?.Numero_Proposta_Prosponente === this.state.key[indexKey],
            );

            this.setState({
              personal: {
                ...this.state.personal,
                tipo: personalState?.tipo,
                propostas: [
                  ...this.state.personal?.propostas,
                  personalState?.propostas[indexValue],
                ],
              },
            });
          };

          if (!this.state.key.includes(value.key)) {
            this.setState({ key: [...key, value.key] }, logtest);
          } else {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            const indexValue = this.state.personal?.propostas?.findIndex(
              (index: any) => index?.Numero_Proposta_Prosponente === value.key,
            );

            const removeItem = this.state.key;

            removeItem.splice(indexKey, 1);

            const removeItemIndexValue = this.state.personal?.propostas;

            removeItemIndexValue.splice(indexValue, 1);

            this.setState({
              key: removeItem,
              personal: {
                ...this.state.personal,
                propostas: removeItemIndexValue,
              },
            });
          }
        }
      }

      for (let i = 0; i < personalState?.proposta?.length; i++) {
        const element = personalState?.proposta[i];
        if (element?.Numero_Proposta === value.key) {
          const logtest = () => {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            let indexValue = personalState?.proposta?.findIndex(
              (index: any) =>
                index?.Numero_Proposta === this.state.key[indexKey],
            );

            this.setState({
              personal: {
                ...this.state.personal,
                tipo: personalState?.tipo,
                proposta: [
                  ...this.state.personal?.proposta,
                  personalState?.proposta[indexValue],
                ],
              },
            });
          };

          if (!this.state.key.includes(value.key)) {
            this.setState({ key: [...key, value.key] }, logtest);
          } else {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            const indexValue = this.state.personal?.proposta?.findIndex(
              (index: any) => index?.Numero_Proposta === value.key,
            );

            const removeItem = this.state.key;

            removeItem.splice(indexKey, 1);

            const removeItemIndexValue = this.state.personal?.proposta;

            removeItemIndexValue.splice(indexValue, 1);

            this.setState({
              key: removeItem,
              personal: {
                ...this.state.personal,
                proposta: removeItemIndexValue,
              },
            });
          }
        }
      }

      for (
        let i = 0;
        i < personalState?.generic_logical_unit_json?.length;
        i++
      ) {
        const element = personalState?.generic_logical_unit_json[i];

        if (element.internalControlLGPDPreintThisPage === value.key) {
          const logtest = () => {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            let indexValue =
              personalState?.generic_logical_unit_json?.findIndex(
                (element: any) =>
                  element.internalControlLGPDPreintThisPage ===
                  this.state.key[indexKey],
              );

            this.setState({
              personal: {
                ...this.state.personal,
                tipo: personalState?.tipo,
                generic_logical_unit_json: [
                  ...this.state.personal?.generic_logical_unit_json,
                  personalState?.generic_logical_unit_json[indexValue],
                ],
              },
            });
          };

          if (!this.state.key.includes(value.key)) {
            this.setState({ key: [...key, value.key] }, logtest);
          } else {
            const indexKey = this.state.key.findIndex(
              index => index === value.key,
            );

            const indexValue =
              this.state.personal?.generic_logical_unit_json?.findIndex(
                (element: any) =>
                  element.internalControlLGPDPreintThisPage === value.key,
              );

            const removeItem = this.state.key;

            removeItem.splice(indexKey, 1);

            const removeItemIndexValue =
              this.state.personal?.generic_logical_unit_json;

            removeItemIndexValue.splice(indexValue, 1);

            this.setState({
              key: removeItem,
              personal: {
                ...this.state.personal,
                generic_logical_unit_json: removeItemIndexValue,
              },
            });
          }
        }
      }
    }
  };

  printDocument = () => {
    //@ts-ignore
    document.getElementsByTagName('aside')[0].hidden = true;
    //@ts-ignore
    document.getElementsByTagName('nav')[0].hidden = true;
    //@ts-ignore
    document.querySelector('.content-wrapper > div').style.display = 'none';
    //@ts-ignore
    document.querySelector(
      '.content-wrapper > section > div > div.content > div > div.actionContainer',
      //@ts-ignore
    ).style.display = 'none';
    //@ts-ignore
    window.print();

    //@ts-ignore
    document.getElementsByTagName('aside')[0].hidden = false;
    //@ts-ignore
    document.getElementsByTagName('nav')[0].hidden = false;
    //@ts-ignore
    document.querySelector('.content-wrapper > div').style.display = 'block';
    //@ts-ignore
    document.querySelector(
      '.content-wrapper > section > div > div.content > div > div.actionContainer',
      //@ts-ignore
    ).style.display = 'block';
  };

  renderContratos = () => {
    const personalState = this.props.personalState.data;

    const renderItmes: any[] = [];

    personalState?.assinante?.forEach((element: any) => {
      if (element?.dadosPessoais?.Codigo_Cliente_Siebel) {
        renderItmes.push({
          conta: element?.dadosPessoais?.Codigo_Cliente_Siebel,
        });
      }
    });

    personalState?.dados_cadastrais_funcionario?.forEach((element: any) => {
      if (element?.Dados_Cadastrais?.Matricula_Empregado) {
        renderItmes.push({
          conta: element?.Dados_Cadastrais?.Matricula_Empregado,
        });
      }
    });

    personalState?.instaladores?.forEach((element: any) => {
      if (element?.Numero_instalador) {
        renderItmes.push({ conta: element?.Numero_instalador });
      }
    });

    personalState?.terceiros?.forEach((element: any) => {
      renderItmes.push({ conta: element?.conta });
    });

    personalState?.pontos_de_venda?.forEach((element: any) => {
      renderItmes.push({ conta: element?.conta });
    });

    personalState?.dados_cadastrais_candidato?.forEach((element: any) => {
      renderItmes.push({ conta: element?.CPF_Candidato });
    });

    personalState?.propostas?.forEach((element: any) => {
      renderItmes.push({ conta: element?.Numero_Proposta_Prosponente });
    });

    personalState?.proposta?.forEach((element: any) => {
      renderItmes.push({ conta: element?.Numero_Proposta });
    });

    personalState?.generic_logical_unit_json?.forEach((element: any) => {
      renderItmes.push({ conta: element.internalControlLGPDPreintThisPage });
    });

    return renderItmes.map((selectCount: any, index: any) => {
      if (!!selectCount.conta) {
        return (
          <FormControlLabelLGPD
            key={`keys${index}`}
            control={
              <Checkbox
                onChange={e => {
                  this.handleChecked({
                    key: selectCount.conta,
                    value: e.target.checked,
                  });
                }}
                name="checkedB"
                color="primary"
              />
            }
            label={selectCount.conta}
          />
        );
      }
      return <p style={{ color: 'red' }}>você não tem contratos</p>;
    });
  };

  renderInfoTypeFour = () => {
    const { personal } = this.state;

    const instaladores = !!personal.instaladores[0];
    const terceiros = !!personal.terceiros[0];
    const pontos_de_venda = !!personal.pontos_de_venda[0];
    const assinante = !!personal.assinante[0];
    const dados_cadastrais_funcionario =
      !!personal.dados_cadastrais_funcionario[0];
    const propostas = !!personal.propostas[0];
    const proposta = !!personal.proposta[0];
    const dados_cadastrais_candidato = !!personal.dados_cadastrais_candidato[0];
    const generic_logical_unit_json =
      !!personal?.generic_logical_unit_json &&
      personal.generic_logical_unit_json[0];

    if (
      instaladores ||
      terceiros ||
      pontos_de_venda ||
      assinante ||
      dados_cadastrais_funcionario ||
      propostas ||
      proposta ||
      dados_cadastrais_candidato ||
      generic_logical_unit_json
    ) {
      return <Categorias personalData={personal} />;
    }
  };

  render() {
    const { personalState, personalExportLogRequest } = this.props;

    return (
      <Container>
        <HeaderPage pageTitle="Exportar Informações e operações" />

        <div className="content">
          <h2>Selecione a(s) conta(s) para exportação dos dados</h2>

          {!personalState.loading && this.renderContratos()}

          <div className="orderContainer">
            <div id="divToPrint">{this.renderInfoTypeFour()}</div>

            <div className="actionContainer">
              <div className="buttons">
                <StyledButton
                  onClick={() => {
                    personalExportLogRequest();
                    this.printDocument();
                  }}
                >
                  Exportar
                </StyledButton>
              </div>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  auth: state.auth,
  profile: state.user.profile,
  language: state.language.data,
  consentimentos: state.consentimentos.data,
  personalState: state.mostrarInformacoesPessoais,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators(
    { consentimentosRequest, personalRequest, personalExportLogRequest },
    dispatch,
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExportarInformacoesOperacoes);
